import request from "../utils/request";

export const list = () => (data) => request.get("/api/app_user", data);
export const select = (data) => request.get("/api/app_user/select", data);
export const create = (data) => request.post("/api/app_user", data);
export const update = (id, data) => request.put(`/api/app_user/${id}`, data);
export const password = (id, data) => request.put(`/api/app_user/${id}/password`, data);
export const remove = (id) => request.del(`/api/app_user/${id}`);
export const get = (id) => request.get(`/api/app_user/${id}`);